  import axios, { AxiosError, AxiosResponse } from "axios";
import { clientConfig, handleAxiosError } from "../../../shared/helpers/utils";
const HOSTA_API='https://grpapi.optionedge.in/'
const api = axios.create({
  baseURL: HOSTA_API,
});

api.interceptors.request.use(
  (config) => {
    return clientConfig(config);
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (err: AxiosError) => {
    if (err.response?.status === 401) {
      handleAxiosError();
    }

    return Promise.reject(err);
  }
);

export default api;
